{
  "Accessibility Menu": "Tilgjengelighetsmeny",
  "Reset settings": "Tilbakestill innstillinger",
  "Close": "Lukk",
  "Content Adjustments": "Innholdstilpasninger",
  "Adjust Font Size": "Juster skriftstørrelse",
  "Highlight Title": "Fremhev tittel",
  "Highlight Links": "Fremhev lenker",
  "Readable Font": "Lesbar skrifttype",
  "Color Adjustments": "Fargejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høy kontrast",
  "High Saturation": "Høy metning",
  "Low Saturation": "Lav metning",
  "Monochrome": "Monokrom",
  "Tools": "Verktøy",
  "Reading Guide": "Leseguide",
  "Stop Animations": "Stopp animasjoner",
  "Big Cursor": "Stor peker",
  "Increase Font Size": "Øk skriftstørrelsen",
  "Decrease Font Size": "Reduser skriftstørrelsen",
  "Letter Spacing": "Bokstavavstand",
  "Line Height": "Linjehøyde",
  "Font Weight": "Skriftvekt",
  "Dyslexia Font": "Dysleksisk skrifttype",
  "Language": "Språk",
  "Open Accessibility Menu": "Åpne tilgjengelighetsmeny"
}
